// extracted by mini-css-extract-plugin
module.exports = {"channelHeaderRoot":"ChannelHeader_channelHeaderRoot__FAKWP","channelHeaderH2":"ChannelHeader_channelHeaderH2__eG_tW","image":"ChannelHeader_image__lKLAP"};